import { render, staticRenderFns } from "./PostalShippingSettings.vue?vue&type=template&id=66fb51a2&scoped=true&"
import script from "./PostalShippingSettings.vue?vue&type=script&lang=js&"
export * from "./PostalShippingSettings.vue?vue&type=script&lang=js&"
import style0 from "./PostalShippingSettings.vue?vue&type=style&index=0&id=66fb51a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66fb51a2",
  null
  
)

export default component.exports